import React, { useState } from 'react';
import './DomainInternational.css';

const DomainInternational = () => {
  const [domainName, setDomainName] = useState('');
  const [selectedTld, setSelectedTld] = useState('.com');

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const internationalTlds = [
    { tld: '.com', price: '۱۲۰,۰۰۰', description: 'محبوب‌ترین دامنه جهانی برای کسب‌وکارها', popular: true },
    { tld: '.net', price: '۱۱۰,۰۰۰', description: 'مناسب برای شرکت‌های شبکه و فناوری اطلاعات' },
    { tld: '.org', price: '۱۰۰,۰۰۰', description: 'مناسب برای سازمان‌های غیرانتفاعی و موسسات' },
    { tld: '.info', price: '۹۵,۰۰۰', description: 'مناسب برای وب‌سایت‌های اطلاع‌رسانی' },
    { tld: '.io', price: '۱۵۰,۰۰۰', description: 'محبوب در بین استارتاپ‌ها و شرکت‌های فناوری' },
    { tld: '.co', price: '۱۳۰,۰۰۰', description: 'جایگزین مناسب برای .com با هویت سازمانی' },
    { tld: '.shop', price: '۱۴۰,۰۰۰', description: 'مناسب برای فروشگاه‌های آنلاین و تجارت الکترونیک' },
    { tld: '.online', price: '۱۱۰,۰۰۰', description: 'مناسب برای کسب‌وکارهای آنلاین و خدمات دیجیتال' },
    { tld: '.store', price: '۱۳۵,۰۰۰', description: 'مناسب برای فروشگاه‌های اینترنتی و برندهای خرده‌فروشی' },
    { tld: '.tech', price: '۱۲۵,۰۰۰', description: 'مناسب برای شرکت‌های فناوری و استارتاپ‌های تکنولوژی' },
    { tld: '.dev', price: '۱۴۵,۰۰۰', description: 'مناسب برای توسعه‌دهندگان و برنامه‌نویسان' },
    { tld: '.app', price: '۱۵۵,۰۰۰', description: 'مناسب برای اپلیکیشن‌های موبایل و وب' },
  ];

  const handleSearch = () => {
    if (!domainName.trim()) {
      alert('لطفاً نام دامنه را وارد کنید');
      return;
    }
    let fullDomain = domainName.trim();
    if (!fullDomain.includes('.')) {
      fullDomain += selectedTld;
    }
    window.open('https://hub.afracell.com/cart.php?a=add&domain=register&query=' + encodeURIComponent(fullDomain), '_blank');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const selectTld = (tld) => {
    setSelectedTld(tld);
  };

  const features = [
    {
      icon: '🌍',
      title: 'حضور جهانی با بیش از ۵۰۰ پسوند',
      desc: 'با ثبت دامنه بین‌المللی، برند خود را در سطح جهانی معرفی کنید. بیش از ۵۰۰ پسوند مختلف برای انتخاب دارید تا دامنه‌ای منحصر‌به‌فرد برای کسب‌وکار خود پیدا کنید.',
    },
    {
      icon: '⚡',
      title: 'فعال‌سازی آنی و بدون معطلی',
      desc: 'پس از ثبت دامنه بین‌المللی، بلافاصله فعال می‌شود و می‌توانید از آن استفاده کنید. نیازی به انتظار برای تأیید یا فعال‌سازی نیست.',
    },
    {
      icon: '🔒',
      title: 'حریم خصوصی WHOIS رایگان',
      desc: 'اطلاعات شخصی شما در پایگاه داده WHOIS مخفی می‌ماند و از هرزنامه‌ها و تماس‌های ناخواسته در امان خواهید بود. این سرویس به صورت رایگان ارائه می‌شود.',
    },
    {
      icon: '🔄',
      title: 'انتقال رایگان دامنه به افرسل',
      desc: 'اگر دامنه خود را در جای دیگری ثبت کرده‌اید، می‌توانید به صورت رایگان آن را به افرسل انتقال دهید و از خدمات ما بهره‌مند شوید.',
    },
  ];

  const popularCategories = [
    { name: 'کسب‌وکار و شرکت‌ها', tlds: '.com .net .co .biz .company' },
    { name: 'فناوری و استارتاپ', tlds: '.tech .io .dev .app .ai' },
    { name: 'فروشگاهی و تجارت الکترونیک', tlds: '.shop .store .online .market' },
    { name: 'سازمانی و غیرانتفاعی', tlds: '.org .ngo .foundation .charity' },
  ];

  const faqs = [
    {
      q: 'ثبت دامنه بین‌المللی چه مزایایی دارد و چرا باید از آن استفاده کنم؟',
      a: 'دامنه‌های بین‌المللی مانند .com، .net و .org در سطح جهانی شناخته شده هستند و به شما امکان می‌دهند تا برند خود را به مخاطبان بین‌المللی معرفی کنید. این دامنه‌ها محدودیت جغرافیایی ندارند و برای کسب‌وکارهایی که قصد توسعه بین‌المللی دارند، بسیار مناسب هستند. همچنین، دامنه‌های بین‌المللی معمولاً در نتایج جستجوی گوگل جهانی رتبه بهتری دارند و اعتماد کاربران را جلب می‌کنند.',
    },
    {
      q: 'آیا امکان ثبت دامنه بین‌المللی با قیمت مناسب وجود دارد؟',
      a: 'بله، در افرسل دامنه‌های بین‌المللی با قیمت‌های رقابتی و مناسب ارائه می‌شوند. قیمت ثبت دامنه بسته به پسوند متفاوت است و شما می‌توانید از بین پسوندهای مختلف، بهترین گزینه را با توجه به بودجه خود انتخاب کنید. همچنین، ما تخفیف‌های ویژه برای ثبت دامنه به صورت چندساله در نظر گرفته‌ایم.',
    },
    {
      q: 'آیا می‌توانم دامنه بین‌المللی خود را به افرسل انتقال دهم؟',
      a: 'بله، انتقال دامنه بین‌المللی به افرسل کاملاً رایگان است. شما只需 کد انتقال (Auth Code) را از ثبت‌کننده فعلی خود دریافت کرده و در پنل افرسل وارد کنید. پس از انتقال، یک سال تمدید رایگان به دامنه شما اضافه می‌شود و می‌توانید از خدمات مدیریت DNS پیشرفته ما استفاده کنید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>ثبت دامنه بین‌المللی | خرید دامنه .com .net .org با بهترین قیمت | افرسل</h1>
        <p>ثبت دامنه بین‌المللی با پسوندهای .com، .net، .org و بیش از ۵۰۰ پسوند دیگر. فعال‌سازی آنی، حریم خصوصی WHOIS رایگان، انتقال رایگان و پشتیبانی ۲۴ ساعته. بهترین قیمت ثبت دامنه بین‌المللی را در افرسل تجربه کنید.</p>
        <meta name="description" content="ثبت دامنه بین‌المللی با بهترین قیمت در افرسل. خرید دامنه .com، .net، .org و ۵۰۰+ پسوند دیگر. فعال‌سازی آنی، حریم خصوصی رایگان، انتقال رایگان و پشتیبانی ۲۴/۷." />
      </div>

      <section className="international-hero">
        <div className="international-hero-bg"></div>
        <div className="wrap">
          <div className="international-hero-content">
            <div className="international-badge">
              <span className="pulse-dot"></span>
              🌍 دامنه بین‌المللی
            </div>
            <h1 className="international-hero-title">
              ثبت دامنه <em>بین‌المللی</em>
            </h1>
            <p className="international-hero-desc">
              با ثبت دامنه بین‌المللی، برند خود را در سطح جهانی معرفی کنید. از بین بیش از ۵۰۰ پسوند مختلف، 
              دامنه‌ای منحصر‌به‌فرد برای کسب‌وکار خود انتخاب کنید. فعال‌سازی آنی، حریم خصوصی رایگان و 
              پشتیبانی ۲۴ ساعته از مزایای ثبت دامنه بین‌المللی در افرسل است.
            </p>
            <div className="international-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۵۰۰+</span>
                <span className="stat-label">پسوند مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">آنی</span>
                <span className="stat-label">فعال‌سازی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰٪</span>
                <span className="stat-label">حریم خصوصی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="international-search">
        <div className="wrap">
          <div className="international-search-box">
            <h3 className="international-search-title">دامنه بین‌المللی مورد نظر را جستجو کنید</h3>
            <div className="international-search-input">
              <input
                type="text"
                className="international-input-main"
                placeholder="مثال: mybrand"
                value={domainName}
                onChange={(e) => setDomainName(e.target.value)}
                onKeyDown={handleKeyDown}
                dir="ltr"
              />
              <button className="international-search-btn" onClick={handleSearch}>
                جستجوی دامنه
              </button>
            </div>
            <div className="international-tld-hint">
              <span>پسوندهای محبوب: </span>
              {['.com', '.net', '.org', '.io', '.co'].map((tld, i) => (
                <button
                  key={i}
                  className={`international-tld-btn ${selectedTld === tld ? 'active' : ''}`}
                  onClick={() => selectTld(tld)}
                >
                  {tld}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="international-tlds">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پسوندهای بین‌المللی</span>
            <h2 className="sec-h">دامنه‌های <em>بین‌المللی</em></h2>
            <p className="sec-p">ثبت دامنه‌های بین‌المللی با بیش از ۵۰۰ پسوند مختلف. انتخاب از بین محبوب‌ترین پسوندها با قیمت مناسب.</p>
          </div>
          <div className="international-tlds-grid">
            {internationalTlds.map((tld, i) => (
              <div key={i} className={`international-tld-card ${tld.popular ? 'popular' : ''}`}>
                {tld.popular && <span className="international-tld-popular">پرفروش</span>}
                <div className="international-tld-name">{tld.tld}</div>
                <div className="international-tld-price">{tld.price} تومان</div>
                <div className="international-tld-desc">{tld.description}</div>
                <button className="international-tld-btn-order" onClick={() => {
                  setSelectedTld(tld.tld);
                  document.querySelector('.international-input-main').focus();
                }}>
                  ثبت کنید
                </button>
              </div>
            ))}
          </div>
          <p className="international-tld-note">* بیش از ۵۰۰ پسوند دیگر نیز موجود است. برای استعلام با ما تماس بگیرید.</p>
        </div>
      </section>

      <section className="international-categories">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">دسته‌بندی پسوندها</span>
            <h2 className="sec-h">دامنه بر اساس <em>نوع کسب‌وکار</em></h2>
            <p className="sec-p">انتخاب پسوند مناسب بر اساس نوع کسب‌وکار و حوزه فعالیت شما. هر پسوند برای صنعت خاصی مناسب است.</p>
          </div>
          <div className="international-categories-grid">
            {popularCategories.map((cat, i) => (
              <div key={i} className="international-category-card">
                <h4 className="international-category-name">{cat.name}</h4>
                <p className="international-category-tlds">{cat.tlds}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="international-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای دامنه بین‌المللی</span>
            <h2 className="sec-h">چرا <em>دامنه بین‌المللی</em> ثبت کنیم؟</h2>
            <p className="sec-p">دامنه بین‌المللی به شما امکان می‌دهد تا برند خود را در سطح جهانی معرفی کنید و مخاطبان بین‌المللی را جذب نمایید.</p>
          </div>
          <div className="international-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="international-feature-card">
                <span className="international-feature-icon">{feature.icon}</span>
                <h3 className="international-feature-title">{feature.title}</h3>
                <p className="international-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="international-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">پاسخ سوالات رایج درباره ثبت دامنه بین‌المللی را در این بخش مشاهده کنید.</p>
          </div>
          <div className="international-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="international-faq-item">
                <div className="international-faq-q">{faq.q}</div>
                <div className="international-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="international-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              دامنه <em>بین‌المللی</em> خود را ثبت کنید
            </h2>
            <p className="cta-desc">
              با ثبت دامنه بین‌المللی، حضور جهانی خود را شروع کنید. 
              فعال‌سازی آنی، حریم خصوصی رایگان و پشتیبانی ۲۴ ساعته در کنار شماست.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => document.querySelector('.international-input-main')?.focus()}>
                جستجوی دامنه
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DomainInternational;
